











































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import TreatmentSpotSelectPerTenMinuteTemplate from '@/views/treatment-reservation/organisms/TreatmentSpotSelectPerTenMinuteTemplate.vue'
import TreatmentSpotSelectPerThirtyMinuteTemplate from '@/views/treatment-reservation/organisms/TreatmentSpotSelectPerThirtyMinuteTemplate.vue'
import { ClinicResponse, MedicalTreatmentSpot, Spot } from '@/interface/api'
import { DateFormat, TreatmentCategory } from '@/utils/constants'
import { formatDate } from '@/utils/index'
@Component({
  name: 'SelectDateTimeTemplate',
  components: {
    TreatmentSpotSelectPerTenMinuteTemplate,
    TreatmentSpotSelectPerThirtyMinuteTemplate
  }
})
export default class SelectDateTimeTemplate extends Vue {
  @Prop({ default: '' }) private medicalBusinessId!: string
  @Prop({ default: '' }) private clinicalDepartmentId!: string
  @Prop({ default: '' }) private clinicDeaprtmentTreatmentCourseId!: string
  @Prop({ default: 1 }) private isFirstTreatment!: number
  @Prop({ default: '' }) private treatmentCategoryName!: string
  @Prop({ default: 0 }) private reservationType!: number
  @Prop({ default: () => null }) private selectedClinic!: ClinicResponse
  @Prop({ default: 30 }) private perMinute!: string
  @Prop({ default: () => null }) private clinic!: ClinicResponse
  @Prop({ default: () => [] }) private publicHolidyList!: string[]

  @Prop({ default: () => null }) private medicalTreatmentSpotMap!: Map<
    string,
    Spot[]
  >

  @Prop({ default: () => [] })
  private medicalTreatmentSpots!: MedicalTreatmentSpot[]

  private startDate = new Date()
  private loading = false
  private weeksLater = 0

  private get endDate(): Date {
    return new Date(
      this.startDate.getFullYear(),
      this.startDate.getMonth(),
      this.startDate.getDate() + 6
    )
  }

  private get formatedStartDate(): string {
    return formatDate(this.startDate, DateFormat.YYYYNEN_MGATU)
  }

  private get treatmentCategory() {
    return TreatmentCategory
  }

  private get departmentName() {
    const target = this.clinic!.clinical_departments.find(
      item => item.id === this.clinicalDepartmentId
    )
    return target ? target.name : ''
  }

  private get departmentCourseName() {
    if (!this.clinicDeaprtmentTreatmentCourseId) return ''
    const targetDepartment = this.clinic!.clinical_departments.find(
      item => item.id === this.clinicalDepartmentId
    )
    if (!targetDepartment || !targetDepartment.treatment_courses) return ''
    const targetCourse = targetDepartment.treatment_courses.find(
      course => course.id === this.clinicDeaprtmentTreatmentCourseId
    )
    return targetCourse ? targetCourse.name : ''
  }

  private prev() {
    this.weeksLater--
    this.startDate = new Date(
      this.startDate.setDate(this.startDate.getDate() - 7)
    )
  }

  private next() {
    this.weeksLater++
    this.startDate = new Date(
      this.startDate.setDate(this.startDate.getDate() + 7)
    )
  }

  private today() {
    this.weeksLater = 0
    this.startDate = new Date()
  }

  private onBackButtonClick() {
    this.weeksLater = 0
    this.startDate = new Date()
    this.$emit('back')
  }

  @Watch('startDate')
  public async onStartDateChange(): Promise<void> {
    this.$emit('on-start-date-change', this.startDate)
  }
}
